import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import utils from '@utils';

import './PaymentConfirmationModal.scss';

class PaymentConfirmationModal extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			show  : false,
			total : 0,
		};
	}

	openModal = ({ total }) => {
		this.setState({
			show : true,
			total,
		});
	}

	onClose = () => {
		this.setState({ show : false });
	}

	onDoneClick = () => {
		const { onDone } = this.props;
		this.setState({ show : false }, onDone);
	}

	onPrintReceiptClick = () => {
		const { onPrintReceipt } = this.props;
		this.setState({ show : false }, onPrintReceipt);
	}

	render() {
		const {
			show, total,
		} = this.state;

		return (
			<Fragment>
				<Modal
					keyboard={false}
					backdrop="static"
					show={show}
					onHide={this.onClose}
					id="payment-confirmation-modal"
				>
					<Modal.Header>
						<Modal.Title>
							<div id="payment-confirmation-total">
								{utils.currencyFormatter(total)}
							</div>
							<span id="payment-confirmation-paid-label" className="label label-success">Paid</span>
						</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<div>
							<img
								src="/images/checkmark.png"
								alt="checkmark"
							/>
						</div>
						<div id="payment-confirmation-success-title">Payment was successful</div>
						<div id="payment-confirmation-success-message">We have successfully processed your payment.</div>
						<div id="payment-confirmation-thanks">
							Thank you for using
							<span id="rollkall-label"> RollKall</span>
						</div>
					</Modal.Body>
					<Modal.Footer>
						<div id="payment-confirmation-done-btn">
							<button
								type="button"
								className="btn btn-default"
								onClick={this.onDoneClick}
							>
								Done
							</button>
						</div>
						<div id="payment-confirmation-print-btn">
							<button
								type="button"
								className="btn btn-primary"
								onClick={this.onPrintReceiptClick}
							>
								Print Receipt
							</button>
						</div>
					</Modal.Footer>
				</Modal>
			</Fragment>
		);
	}
}

PaymentConfirmationModal.propTypes = {
	onPrintReceipt : PropTypes.func.isRequired,
	onDone         : PropTypes.func.isRequired,
};

export default PaymentConfirmationModal;
